export interface CompanyDiscoveryInfo {
    entity_id: string
    last_funding_date: number // 20170824 YYYYMMDD
    last_funding_total: number
    last_funding_type: string
    num_funding_rounds: number
    rank: number
    startup: boolean
    unicorn: boolean
}

export enum E_ORGANIZATION_TYPE {
    COMPANY = 'Company',
    EDUCATION = 'Education',
    GOVERNMENT = 'Government',
    NONPROFIT = 'Nonprofit'
}

export enum ORG_ANS_TYPE {
    'ANS' = 'ANS',
    'ONEID' = 'ONEID'
}

export enum E_ORGANIZATION_OWNERSHIP_TYPE {
    PUBLIC = 'Public',
    HOLDING = 'Holding',
    JOINT_VENTURE = 'Joint Venture',
    PRIVATE = 'Private',
    SUBSIDIARY = 'Subsidiary'
}

export interface CompanyNormalizedTopic {
    original_index?: number
    original_name: string
    normalized_id: string
    normalized_display_name: string
}

export interface CompanyOffsetInfo {
    entity_id: string
    ownership_type: E_ORGANIZATION_OWNERSHIP_TYPE[]
    normalized_topic?: CompanyNormalizedTopic[]
}

export interface CompanyInfo {
    display_name: string
    description: string
    description_cn: string
    discovery_info: CompanyDiscoveryInfo
    employee_number: number // employee_num: number
    employee_number_interval: string // 10000人以上
    entity_id: string
    emails: string[]
    finance_factset_id: string
    founded_date: number // 20170824 YYYYMMDD
    id: string
    logo: string
    long_description_en: string
    nace_code: string
    naics_code: string[]
    name: string
    name_cn: string
    name_cn_translation: string
    name_en: string
    normalized_entity_status_cn: string
    normalized_entity_type_en: E_ORGANIZATION_TYPE
    offset_info: CompanyOffsetInfo
    original_address: CompanyOriginalAddress
    other_names_en: string[]
    short_description_en: string
    short_name_cn: string
    website: string
    country_id?: string
    state_id?: string
    city_id?: string
    district_id?: string
    subsidiaries?: number
    sort_value?: number
    ans_category?: string
    logo_s3_path: string
    is_ls_related?: boolean
    is_public: boolean
    expert_count: number
    paper_count: number
    citation_count: number
    normalized_last_funding_type?: string
    need_redirect: boolean
    parent_info?: CompanyInfo
    ultimate_parent_info?: CompanyInfo
}

export interface CompanyDisplayInfo extends CompanyInfo {
    organizationType?: string
    foundedYear?: string
    location?: string
    employeeStr?: string
}

export interface CompanyOriginalAddress {
    country?: string
    state?: string
    city?: string
    district?: string
    location?: string
    country_en?: string
}

export interface Query {
    type: string;
    condition: string;
    must: Array<{
        type: string;
        condition: string;
        any: Array<{
            type: string;
            value: string[];
            condition: string;
        }>;
    }>;
}

export interface QueryLayout {
    type: string;
    condition: string;
    value: Array<{
        type: string;
        display_name: string;
    }>;
}

export interface GenerateSearchQueryIdRequest {
    advanced_search: boolean;
    data_type: string;
    query: Query;
    query_layout: QueryLayout[];
}

export interface GenerateSearchQueryIdResponse {
    id: string;
}
